export default __webpack_public_path__ + "static/media/hero.07ebc14c.webp";